// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"ad0af4b1","714":"66155809"}[chunkId] + ".chunk.js";
};